/** Ruta de Sesiones activas, para los pasos que navegan solos. */
export const ACTIVE_SESSIONS_ROUTE = '/admin/active-sessions';
